import React from 'react';
import { FeedItem } from './FeedItem';
import { ActionProps, getActivityTypeInfo } from './ActivityFeed';

export const FollowAction = (props: ActionProps) => {
  const { activity } = props;
  const { objectType } = activity;
  const info = getActivityTypeInfo(activity)[objectType];

  return <FeedItem didWhat={`followed ${info.label}`} onWhat={{ name: info.name, url: info.path }} />;
};
